import { agencies as agencyRoute } from '@/app/routes';
import type { ErrorMsgType, MsgPageType } from '@/types/error-message';

export const ERROR_CODES = [500, 404, 400];
export const ERROR_MESSAGES: Record<MsgPageType, Record<number, ErrorMsgType>> = {
  defaultMessages: {
    500: {
      message: 'Hups! Sivun näyttämisessä tapahtui virhe.',
      backButtonText: 'Palaa etusivulle',
      returnUrl: '/',
    },
    404: {
      message: 'Hups! Etsimääsi sivua ei löytynyt.',
      backButtonText: 'Palaa etusivulle',
      returnUrl: '/',
    },
    400: {
      message: 'Hups! Etsimääsi sivua ei löytynyt.',
      backButtonText: 'Palaa etusivulle',
      returnUrl: '/',
    },
  },
  listing: {
    500: {
      message: 'Etsimääsi kohdetta ei voitu näyttää.',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: '/myytavat/asunnot',
    },
    404: {
      message: 'Etsimääsi kohdetta ei löytynyt.',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: '/myytavat/asunnot',
    },
    400: {
      message: 'Etsimääsi kohdetta ei löytynyt.',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: '/myytavat/asunnot',
    },
  },
  agency: {
    500: {
      message: 'Etsimääsi toimipistettä ei voitu näyttää.',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: agencyRoute.path,
    },
    404: {
      message: 'Etsimääsi toimipistettä ei löytynyt.',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: agencyRoute.path,
    },
    400: {
      message: 'Etsimääsi toimipistettä ei löytynyt',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: agencyRoute.path,
    },
  },
  agent: {
    500: {
      message: 'Etsimääsi välittäjää ei voitu näyttää.',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: agencyRoute.path,
    },
    404: {
      message: 'Etsimääsi välittäjää ei löytynyt.',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: agencyRoute.path,
    },
    400: {
      message: 'Etsimääsi välittäjää ei löytynyt',
      backButtonText: 'Palaa hakusivulle',
      returnUrl: agencyRoute.path,
    },
  },
  landing: {
    500: { message: 'Sivusto on väliaikaisesti poissa käytöstä.' },
    404: { message: 'Sivusto on väliaikaisesti poissa käytöstä.' },
    400: { message: 'Sivusto on väliaikaisesti poissa käytöstä.' },
  },
  login: {
    500: {
      message: 'Hups! Kirjautuminen epäonnistui.',
      backButtonText: 'Yritä uudelleen',
      returnUrl: '/kirjaudu',
    },
    404: {
      message: 'Hups! Kirjautuminen epäonnistui.',
      backButtonText: 'Yritä uudelleen',
      returnUrl: '/kirjaudu',
    },
    400: {
      message: 'Hups! Kirjautuminen epäonnistui.',
      backButtonText: 'Yritä uudelleen',
      returnUrl: '/kirjaudu',
    },
  },
  // NOTICE: when adding new messages, add also the corresponding page name in config/ui.js
};
export const CONDITION_TYPES = [
  {
    id: '119',
    name: 'Uusi',
  },
  {
    id: '120',
    name: 'Hyvä',
  },
  {
    id: '121',
    name: 'Tyydyttävä',
  },
  {
    id: '122',
    name: 'Välttävä',
  },
];
export const SHORE_TYPES = [
  {
    id: 345,
    name: 'Järvi',
  },
  {
    id: 346,
    name: 'Meri',
  },
  {
    id: 347,
    name: 'Lampi',
  },
  {
    id: 348,
    name: 'Joki',
  },
  {
    id: 498,
    name: 'Muu rantatyyppi',
  },
];
export const SHORE_PRIVILEGES = [
  {
    id: 288,
    name: 'Oma ranta',
  },
  {
    id: 289,
    name: 'Osuus vesialueisiin',
  },
  {
    id: 290,
    name: 'Yhteisranta',
  },
  {
    id: 291,
    name: 'Rannan käyttöön liittyvä oikeus',
  },
  {
    id: 292,
    name: 'Laiturioikeus',
  },
  {
    id: 293,
    name: 'Venevalkamaoikeus',
  },
  {
    id: 294,
    name: 'Ei rantaa',
  },
];
export const VALIDATION_ERRORS = {
  agency: {
    message: 'Syötä paikkakunta tai toimipiste',
    className: 'missing-agency',
  },
  region: {
    message: 'Syötä paikkakunta',
    className: 'missing-region',
  },
  office: {
    message: 'Valitse toimipiste',
    className: 'missing-office',
  },
  email: {
    message: 'Sähköpostiosoite on väärässä muodossa',
    className: 'incorrect-email',
  },
  missingEmail: {
    message: 'Syötä sähköpostiosoite johon PDF lähetetään',
    className: 'missing-email',
  },
  phone: {
    message: 'Puhelinnumero on väärässä muodossa',
    className: 'incorrect-telephone',
  },
  messageContent: {
    message: 'Syötä lähetettävä viesti',
    className: 'missing-message',
  },
  name: {
    message: 'Syötä sekä etu- että sukunimi',
    className: 'missing-name',
  },
  contact: {
    message: 'Syötä sähköpostiosoite tai puhelinnumero',
    className: 'missing-contact',
  },
  noEmailInput: {
    message: 'Syötä sähköpostiosoite',
    className: 'no-email-input',
  },
  noPhoneInput: {
    message: 'Syötä puhelinnumero',
    className: 'no-phone-input',
  },
};
